module.exports = __webpack_public_path__ + "static/img/ic_write@2x.b911328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_write@2x.png
// module id = bL9S
// module chunks = 1